import { createHook, createSelector, type BoundActions } from 'react-sweet-state';
import type { State, ThirdPartyEntity, ThirdPartyState } from '../../../../common/types';
import type { Actions } from '../../actions';
import { Store } from '../../main';

export type ThirdPartySubfolders = {
	selectedSubfolders: ThirdPartyEntity[] | null;
	selectedFolderIds: string[] | null;
};

export type UseThirdPartySubfolders = () => [
	ThirdPartySubfolders,
	Partial<BoundActions<State, Actions>>,
];

export const thirdPartySubfoldersSelector = createSelector(
	(state: State): ThirdPartyState => state.thirdPartyState,
	(newState: ThirdPartyState): ThirdPartySubfolders => {
		const { folders, subfolders, selectedFolderId, selectedSubfolderId } = newState;
		if (selectedFolderId === null || folders === null) {
			return {
				selectedSubfolders: null,
				selectedFolderIds: null,
			};
		}
		const selectedSubfolders = subfolders?.[selectedFolderId] || [];
		if (selectedSubfolderId !== null) {
			return {
				selectedSubfolders,
				selectedFolderIds: [selectedSubfolderId],
			};
		}

		return {
			selectedSubfolders,
			selectedFolderIds: [selectedFolderId],
		};
	},
);

export const useThirdPartySubfolders = createHook(Store, {
	selector: thirdPartySubfoldersSelector,
});
